interface Environment {
	VITE_MSAL_CLIENT_ID: string;
	VITE_MSAL_AUTHORITY_URL: string;
	VITE_MSAL_BACKEND_SCOPE: string;
	VITE_API_BASE_URL: string;
	VITE_APP_NAME: string;
}

function validateEnv(): Environment {
	const env: Environment = {
		VITE_MSAL_CLIENT_ID: import.meta.env.VITE_MSAL_CLIENT_ID,
		VITE_MSAL_AUTHORITY_URL: import.meta.env.VITE_MSAL_AUTHORITY_URL,
		VITE_MSAL_BACKEND_SCOPE: import.meta.env.VITE_MSAL_BACKEND_SCOPE,
		VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
		VITE_APP_NAME: import.meta.env.VITE_APP_NAME,
	};

	const missing = Object.entries(env)
		.filter(([, value]) => !value)
		.map(([key]) => key);

	if (missing.length > 0) {
		throw new Error(`Missing environment variables: ${missing.join(', ')}`);
	}

	return env;
}

export const ENV = validateEnv();

export const ENVIRONMENT_MODE = import.meta.env.MODE;

export const isDev = ENVIRONMENT_MODE === 'dev';

export const isQA = ENVIRONMENT_MODE === 'qa';

export const isProduction = ENVIRONMENT_MODE === 'prod' || ENVIRONMENT_MODE === 'production';

export enum AuthMode {
	Demo = 'demo',
	Real = 'real',
}

export const AUTH_MODE: AuthMode = (import.meta.env.VITE_AUTH_MODE as AuthMode | undefined) ?? AuthMode.Demo;
